import { exampleUser, User } from '../user';

export type AdCreativeReviewOrigin = 'internal' | 'external';

export interface AdCreativeReview {
  id: number;
  creativeID: number;
  user: User;
  type: AdCreativeReviewOrigin;
  approved: boolean;
  /** Set on AE-attested client approvals captured from a Sprint Packet. */
  clientApproverName?: string;
  notes?: string;
  /** True when an Employee attested this external approval on behalf of the client. */
  clientAttestedByEmployee?: boolean;
  createdAt: number;
  updatedAt: number;
}

export const exampleAdCreativeReview: AdCreativeReview = {
  id: 1,
  creativeID: 1,
  user: exampleUser,
  type: 'internal',
  approved: true,
  createdAt: 0,
  updatedAt: 0,
};

export interface AdCreativeReviewDTO {
  approved: boolean;
  /**
   * When true and the session user is an Employee, records an external (client)
   * approval attested on the client's behalf. Allowed from any pre-published
   * state (Draft/Pending/Ready/Rejected); only a Published creative is blocked.
   * When set, `clientApproverName` is required (non-empty).
   */
  onBehalfOfClient?: boolean;
  clientApproverName?: string;
  notes?: string;
}
